// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__IzWxY","cell":"ColumnAccessor_cell__3p8M9","firstCellAccent":"ColumnAccessor_firstCellAccent__JfMrR"};